/**
 * @owner @Appboy/whats-app
 * Common schema to share between response GET and POST shapes
 */

import { z } from "zod";

/**
 * Export to satisfy "Ensure the file exports schemas with a "Schema" suffix." rule
 */
export const whatsAppResponseMessageCommonSchema = z.object({
  message_type: z.literal("whatsApp"),
  whats_app_message_type: z.literal("response"),
  click_tracking_enabled: z.boolean().optional(),
});
